export default __webpack_public_path__ + "static/media/FinancialAidApplicationForm.5a6b94a5.pdf";